"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterTriStateCheckBox = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const tristatecheckbox_1 = require("primereact/tristatecheckbox");
function filterTriStateCheckBox(options, text1, text2, text3) {
    const label = options.value === null ? text1 : (options.value ? text2 : text3);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "field-checkbox m-0" }, { children: [(0, jsx_runtime_1.jsx)(tristatecheckbox_1.TriStateCheckbox, { value: options.value, onChange: (e) => options.filterApplyCallback(e.value) }), (0, jsx_runtime_1.jsx)("label", { children: label })] })));
}
exports.filterTriStateCheckBox = filterTriStateCheckBox;
